import { render, staticRenderFns } from "./EditCupCode.vue?vue&type=template&id=2f3b420c"
import script from "./EditCupCode.vue?vue&type=script&lang=ts"
export * from "./EditCupCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports